import React, { useEffect, useState } from 'react';
import { createPortal } from 'react-dom';

type GeoJsonDownloadModalProps = {
  isShow: boolean;
  onDownloadAll?: () => void;
  onDownloadSingle?: () => void;
  onCancel?: () => void;
};

function GeoJsonDownloadModal(props: GeoJsonDownloadModalProps) {

  const modalRoot = document.getElementById("modal-root");

  useEffect(() => {
    
  }, [props.isShow]);

  const onDownloadAll = () => {
    if (props.onDownloadAll) {
      props.onDownloadAll();
    }
  };

  const onDownloadSingle = () => {
    if (props.onDownloadSingle) {
      props.onDownloadSingle();
    }
  };

  const onClickCancel = () => {
    if (props.onCancel) {
      props.onCancel();
    }
  };

  return (
    modalRoot && props.isShow ?
      createPortal(
        <div className="modal2">
          <div className="modal2-content">
            <div className="modal2-text">GeoJsonをダウンロードしますか？</div>
            <div className="modal2-buttons">
              <button
                onClick={props.onCancel}
                className="uk-button--m uk-button-cancel"
              >
                キャンセル
              </button>
              <button
                onClick={props.onDownloadAll}
                className="uk-button--m uk-button-refer uk-margin-left width-230"
              >
                すべてのファイルをダウンロード
              </button>
              <button
                onClick={props.onDownloadSingle}
                className="uk-button--m uk-button-refer uk-margin-left width-230"
              >
                1ファイルずつ個別にダウンロード
              </button>
          </div>
        </div>
      </div>, modalRoot
      )
        : null
  );
}

export default GeoJsonDownloadModal;
